import SourceFlowText from "@sourceflow-uk/sourceflowtext"
import SourceFlowImage from "@sourceflow-uk/sourceflowimage"
import consultants from '../../.sourceflow/consultants.json'
import jobs from '../../.sourceflow/jobs.json'
import {
    CardBody,
    List,
    Card
} from "reactstrap";
import Link from 'next/link';
import styles from './styles.module.scss';
import LinkedIn from '/public/site-assets/svg/linkedin.svg';
import Mail from '/public/site-assets/svg/mail.svg';

export default function JobConsultant({
    global,
    pathPrefix,
    jobId,
    customClass = "",
    emailText,
    heading
}) {
    const job = jobs.jobs.find((job) => job.id == jobId)
    const consultant = getConsultant(job)
    return (
        consultant?.title.en ?
            <section className={`${styles.root} ${customClass}`}>
                {consultant?.title.en ?
                    <Card className="border-0 position-relative">
                        {heading ?
                            <div className="text-center">
                                <SourceFlowText global={global} path={`${pathPrefix}.consultant.content`} type="html">{heading} </SourceFlowText>
                            </div> : null}
                        <div className="text-center position-relative">
                            <SourceFlowImage
                                src={consultant?.image?.en ? consultant?.image?.en : "/site-assets/images/image-placeholder.webp"}
                                size="800x800"
                                alt={consultant?.title?.en}
                                className="card-img"
                            />
                        </div>
                        <CardBody className="text-center">
                            <p className="fs-5 mb-0 post-title"><strong>{consultant?.title?.en}</strong></p>
                            <p><small>{consultant?.position?.en}</small></p>
                            <List className="consultant-contact m-0 d-flex justify-content-center" type="unstyled">
                                {consultant.email?.en ?
                                    <li>
                                        <Link href={`mailto:${consultant.email?.en}`}>
                                            <a className="d-flex align-items-center" aria-label="Email" title="Email">
                                                <Mail />
                                            </a>
                                        </Link>
                                    </li> : null}
                                {consultant.linkedin?.en ?
                                    <li>
                                        <Link href={`${consultant.linkedin?.en}`}>
                                            <a className="d-flex align-items-center" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn" title="LinkedIn">
                                                <LinkedIn />
                                            </a>
                                        </Link>
                                    </li> : null}
                            </List>
                        </CardBody>
                    </Card >
                    : null
                }
            </section >
            : ""
    )
}

function getConsultant(job) {
    return consultants.category_values.find((consultant) => consultant.email?.en == job.consultant_email)
}